import React, { useState } from 'react';
import {
    Card,
    CardContent,
    Typography,
    Grid,
    Box,
    Divider,
    Paper,
    Avatar
} from '@material-ui/core';
import {
    Person,
    LocationOn,
    Business,
    Description,
    CheckCircle,
    Schedule,
    Error,
    Refresh,
    Phone,
    Email,
    CreditCard,
    AccountBox
} from '@material-ui/icons';
import {
    Dialog,
    DialogContent,
    IconButton
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

export const StatusDataDisplay = ({ headerStatus }) => {
    const [imageErrors, setImageErrors] = useState({});
    const [zoomedImage, setZoomedImage] = useState(null);

    const handleImageError = (imageName) => {
        setImageErrors(prev => ({
            ...prev,
            [imageName]: true
        }));
    };

    const getStatusBackgroundColor = (status) => {
        switch (status) {
            case 'SUCCESS':
            case 'ACCEPT':
                return '#2e7d32'; // green
            case 'PROCESS':
                return '#fcd303'; // yellow
            case 'REFUND':
                return '#0384fc'; // blue
            case 'FAILURE':
            case 'REJECT':
                return '#d32f2f'; // red
            default:
                return '#f2edf2'; // default light gray
        }
    };
    const getStatusIcon = (status) => {
        switch (status?.toUpperCase()) {
            case 'SUCCESS': return <CheckCircle />;
            case 'PROCESS': return <Schedule />;
            case 'FAILED': return <Error />;
            default: return <Refresh />;
        }
    };

    if (!headerStatus) {
        return (
            <Card style={{ margin: 16, padding: 16, textAlign: 'center' }}>
                <CardContent>
                    <Typography variant="body1" color="textSecondary">No data available</Typography>
                </CardContent>
            </Card>
        );
    }

    const imageFields = [
        { key: 'PanCardPath', label: 'PAN', icon: <CreditCard /> },
        { key: 'SelfiePath', label: 'Selfie', icon: <Person /> },
        { key: 'ShopPhotoPath', label: 'Shop Photo', icon: <Business /> },
        { key: 'ElectricityBillPath', label: 'Address Proof of Shop / Electricity Bill', icon: <Description /> },
        { key: 'CancelledChequePath', label: 'Cancel Cheque', icon: <Description /> },
        { key: 'GSTDocumentPath', label: 'GST Document', icon: <Description /> },
        { key: 'AadhaarCardFrontPath', label: 'Aadhaar Front', icon: <AccountBox /> },
        { key: 'AadhaarCardBackPath', label: 'Aadhaar Back', icon: <AccountBox /> },
    ];

    return (
        <Box style={{ minHeight: '100vh', marginBottom: '20px' }}>
            {/* First Row: Status & Remarks + Personal Info */}
            <Grid container spacing={2} style={{ marginBottom: 16 }}>
                {/* First Tile: Status and Remarks */}
                <Grid item xs={12} md={6}>
                    <Card style={{ height: '100%', border: '1px solid #0384fc' }}>
                        <CardContent style={{ padding: 16 }}>
                            <Box display="flex" alignItems="center" style={{ marginBottom: 16, backgroundColor: '#0384fc', padding: 12, borderRadius: 4, color: 'white' }}>
                                <Avatar style={{ width: 30, height: 30, marginRight: 12, backgroundColor: '#0a0a0a' }}>
                                    <Person fontSize="small" />
                                </Avatar>

                                <Typography variant="body1" style={{ fontWeight: 'bold', fontSize: '1rem' }}>{headerStatus.PersonName}</Typography>
                            </Box>


                            <Grid container spacing={1} style={{ marginBottom: 12 }}>


                                <Grid item xs={12} sm={6}>
                                    <Box
                                        display="flex"
                                        alignItems="center"
                                        style={{
                                            padding: 8,
                                            border: '1px solid #0384fc',
                                            borderRadius: 4,
                                            backgroundColor: getStatusBackgroundColor(headerStatus.Status)
                                        }}
                                    >
                                        <Box style={{ color: '#ffffff', marginRight: 6 }}>
                                            {getStatusIcon(headerStatus.Status)}
                                        </Box>
                                        <Box>
                                            <Typography variant="caption" color="textSecondary" style={{ fontSize: '0.8rem' }}>
                                                OnlyAPI- Admin Status
                                            </Typography>
                                            <Typography variant="body2" style={{ fontWeight: 'bold', fontSize: '1rem' }}>
                                                {headerStatus.Status}
                                            </Typography>
                                        </Box>
                                    </Box>
                                </Grid>

                                <Grid item xs={12} sm={6}>
                                    <Box
                                        display="flex"
                                        alignItems="center"
                                        style={{
                                            padding: 8,
                                            border: '1px solid #0384fc',
                                            borderRadius: 4,
                                            backgroundColor: getStatusBackgroundColor(headerStatus.BankStatus)
                                        }}
                                    >
                                        <Box style={{ color: '#ffffff', marginRight: 6 }}>
                                            {getStatusIcon(headerStatus.BankStatus)}
                                        </Box>
                                        <Box>
                                            <Typography variant="caption" color="textSecondary" style={{ fontSize: '0.8rem' }}>
                                                Bank Status
                                            </Typography>
                                            <Typography variant="body2" style={{ fontWeight: 'bold', fontSize: '1rem' }}>
                                                {headerStatus.BankStatus}
                                            </Typography>
                                        </Box>
                                    </Box>
                                </Grid>
                            </Grid>

                            <Box style={{ padding: 8, backgroundColor: '#f2edf2', borderRadius: 4, marginBottom: 6 }}>
                                <Typography variant="caption" style={{ fontSize: '1rem' }}><strong>OnlyAPI- Admin Remark:</strong> {headerStatus.Remark}</Typography>
                            </Box>

                            <Box style={{ padding: 8, backgroundColor: '#f2edf2', borderRadius: 4 }}>
                                <Typography variant="caption" style={{ fontSize: '1rem' }}><strong>Bank Remark:</strong> {headerStatus.BankRemark}</Typography>
                            </Box>
                        </CardContent>
                    </Card>
                </Grid>

                {/* Second Tile: Personal Information */}
                <Grid item xs={12} md={6}>
                    <Card style={{ height: '100%', border: '1px solid #0384fc' }}>
                        <CardContent style={{ padding: 16 }}>
                            <Box display="flex" alignItems="center" style={{ marginBottom: 16, backgroundColor: '#0384fc', padding: 12, borderRadius: 4, color: 'white' }}>
                                <Description style={{ marginRight: 8, fontSize: '1.2rem' }} />
                                <Typography variant="body1" style={{ fontWeight: 'bold', fontSize: '1rem' }}>Personal Information</Typography>
                            </Box>

                            <Grid container spacing={1}>
                                <Grid item xs={12} sm={6}>
                                    <Box style={{ marginBottom: 8 }}>
                                        <Typography variant="caption" color="textSecondary" style={{ fontSize: '1rem' }}>Mobile Number</Typography>
                                        <Typography variant="caption" style={{ display: 'block', fontSize: '1rem' }}>{headerStatus.Mobile}</Typography>
                                    </Box>
                                </Grid>

                                <Grid item xs={12} sm={6}>
                                    <Box style={{ marginBottom: 8 }}>
                                        <Typography variant="caption" color="textSecondary" style={{ fontSize: '1rem' }}>Email Address</Typography>
                                        <Typography variant="caption" style={{ display: 'block', wordBreak: 'break-all', fontSize: '1rem' }}>{headerStatus.Email}</Typography>
                                    </Box>
                                </Grid>

                                <Grid item xs={12} sm={6}>
                                    <Box style={{ marginBottom: 8 }}>
                                        <Typography variant="caption" color="textSecondary" style={{ fontSize: '1rem' }}>PAN</Typography>
                                        <Typography variant="caption" style={{ display: 'block', fontFamily: 'monospace', fontSize: '1rem' }}>{headerStatus.Pan}</Typography>
                                    </Box>
                                </Grid>

                                <Grid item xs={12} sm={6}>
                                    <Box style={{ marginBottom: 8 }}>
                                        <Typography variant="caption" color="textSecondary" style={{ fontSize: '1rem' }}>Aadhaar Number</Typography>
                                        <Typography variant="caption" style={{ display: 'block', fontFamily: 'monospace', fontSize: '1rem' }}>{headerStatus?.Aadhaar || "NA"}</Typography>
                                    </Box>
                                </Grid>

                                <Grid item xs={12} sm={6}>
                                    <Box style={{ marginBottom: 8 }}>
                                        <Typography variant="caption" color="textSecondary" style={{ fontSize: '1rem' }}>GST Number</Typography>
                                        <Typography variant="caption" style={{ display: 'block', fontFamily: 'monospace', fontSize: '1rem' }}>{headerStatus.GSTNumber || "NA"}</Typography>
                                    </Box>
                                </Grid>

                                <Grid item xs={12} sm={6}>
                                    <Box style={{ marginBottom: 8 }}>
                                        <Typography variant="caption" color="textSecondary" style={{ fontSize: '1rem' }}>Application Submitted</Typography>
                                        <Typography variant="caption" style={{ display: 'block', fontFamily: 'monospace', fontSize: '1rem' }}>{headerStatus.DOC || "NA"}</Typography>
                                    </Box>
                                </Grid>
                            </Grid>
                        </CardContent>
                    </Card>
                </Grid>
            </Grid>

            {/* Second Row: Address Information */}
            <Grid container spacing={2} style={{ marginBottom: 16 }}>
                <Grid item xs={12} md={6}>
                    <Card style={{ height: '100%', border: '1px solid #0384fc' }}>
                        <CardContent style={{ padding: 16 }}>


                            <Box display="flex" alignItems="center" style={{ marginBottom: 16, backgroundColor: '#0384fc', padding: 12, borderRadius: 4, color: 'white' }}>
                                <Description style={{ marginRight: 8, fontSize: '1.2rem' }} />
                                <Typography variant="body1" style={{ fontWeight: 'bold', fontSize: '1rem' }}>Personal Address</Typography>
                            </Box>

                            <Typography variant="caption" style={{ display: 'block', marginBottom: 12, padding: 8, backgroundColor: '#f2edf2', borderRadius: 4, fontSize: '1rem' }}>
                                Address: {headerStatus.Address}
                            </Typography>

                            <Grid container spacing={1}>
                                {[
                                    { label: 'Pin Code', value: headerStatus.PinCode },
                                    { label: 'State', value: headerStatus.State },
                                    { label: 'District', value: headerStatus.District },
                                    { label: 'Taluka', value: headerStatus.Taluka },
                                    { label: 'Village', value: headerStatus.Village },
                                    { label: 'Area', value: headerStatus.Area }
                                ].map((item, index) => (
                                    <Grid item xs={6} key={index}>
                                        <Box style={{ marginBottom: 6 }}>
                                            <Typography variant="caption" style={{ display: 'block', fontSize: '1rem' }}>{item.label}: {item.value}</Typography>
                                        </Box>
                                    </Grid>
                                ))}
                            </Grid>
                        </CardContent>
                    </Card>
                </Grid>

                <Grid item xs={12} md={6}>
                    <Card style={{ height: '100%', border: '1px solid #0384fc' }}>
                        <CardContent style={{ padding: 16 }}>


                            <Box display="flex" alignItems="center" style={{ marginBottom: 16, backgroundColor: '#0384fc', padding: 12, borderRadius: 4, color: 'white' }}>
                                <Description style={{ marginRight: 8, fontSize: '1.2rem' }} />
                                <Typography variant="body1" style={{ fontWeight: 'bold', fontSize: '1rem' }}>Shop Address</Typography>
                            </Box>

                            <Typography variant="caption" style={{ display: 'block', marginBottom: 12, padding: 8, backgroundColor: '#f2edf2', borderRadius: 4, fontSize: '1rem' }}>
                                Shop Address: {headerStatus.ShopAddress}
                            </Typography>

                            <Grid container spacing={1}>
                                {[
                                    { label: 'Shop Pin Code', value: headerStatus.ShopPinCode },
                                    { label: 'Shop State', value: headerStatus.ShopState },
                                    { label: 'Shop District', value: headerStatus.ShopDistrict },
                                    { label: 'Shop Taluka', value: headerStatus.ShopTaluka },
                                    { label: 'Shop Village', value: headerStatus.ShopVillage },
                                    { label: 'Shop Area', value: headerStatus.ShopArea },

                                    { label: 'Latitude', value: headerStatus.Latitude },
                                    { label: 'Longitude', value: headerStatus.Longitude },

                                ].map((item, index) => (
                                    <Grid item xs={6} key={index}>
                                        <Box style={{ marginBottom: 6 }}>
                                            <Typography variant="caption" style={{ display: 'block', fontSize: '1rem' }}>{item.label}: {item.value}</Typography>
                                        </Box>
                                    </Grid>
                                ))}
                            </Grid>
                        </CardContent>
                    </Card>
                </Grid>
            </Grid>

            {/* Documents and Images - Full Width Bottom */}
            <Card style={{ border: '1px solid #0384fc' }}>
                <CardContent style={{ padding: 16 }}>
                    <Box display="flex" alignItems="center" style={{ marginBottom: 16, backgroundColor: '#0384fc', padding: 12, borderRadius: 4, color: 'white' }}>
                        <Description style={{ marginRight: 8, fontSize: '1.2rem' }} />
                        <Typography variant="body1" style={{ fontWeight: 'bold', fontSize: '1rem' }}>Documents & Images</Typography>
                    </Box>

                    <Grid container spacing={2}>
                        {imageFields.map((field) => {
                            const imagePath = headerStatus[field.key];
                            if (!imagePath) return null;

                            return (
                                <Grid item xs={6} sm={4} md={3} key={field.key}>
                                    <Card variant="outlined" style={{ border: '1px solid #0384fc' }}>
                                        <Box style={{ padding: 8, backgroundColor: '#446dc7 ', textAlign: 'center' }}>
                                            <Box style={{ marginBottom: 4, color: '#ffffff' }}>
                                                {React.cloneElement(field.icon, { fontSize: 'small' })}
                                                <Typography
                                                    variant="caption"
                                                    style={{ fontWeight: 'bold', fontSize: '1rem', color: '#ffffff' }}
                                                >
                                                    {field.label}
                                                </Typography>
                                            </Box>
                                        </Box>

                                        <Box style={{ padding: 8 }}>
                                            {!imageErrors[field.key] ? (
                                                <img
                                                    src={imagePath}
                                                    alt={field.label}
                                                    style={{
                                                        width: '100%',
                                                        height: '250px', // Increased height
                                                        objectFit: 'cover',
                                                        borderRadius: '4px',
                                                        border: '1px solid #0384fc'
                                                    }}
                                                    onError={() => handleImageError(field.key)}
                                                    onClick={() => setZoomedImage(imagePath)}
                                                />
                                            ) : (
                                                    <Box
                                                        style={{
                                                            height: '250px', // Increased height
                                                            display: 'flex',
                                                            flexDirection: 'column',
                                                            alignItems: 'center',
                                                            justifyContent: 'center',
                                                        backgroundColor: '#f2edf2',
                                                        borderRadius: '4px',
                                                        border: '1px dashed #0384fc'
                                                        }}
                                                    >
                                                        <Error style={{ fontSize: 24, color: '#0384fc', marginBottom: 4 }} />
                                                        <Typography variant="caption" color="textSecondary" style={{ fontSize: '0.6rem' }}>
                                                        Image not available
                                                    </Typography>
                                                </Box>
                                            )}
                                        </Box>
                                    </Card>
                                </Grid>
                            );
                        })}
                    </Grid>
                </CardContent>
            </Card>
            <Dialog open={Boolean(zoomedImage)} onClose={() => setZoomedImage(null)} maxWidth="md">
                <DialogContent style={{ position: 'relative', padding: 0 }}>
                    <IconButton
                        onClick={() => setZoomedImage(null)}
                        style={{ position: 'absolute', top: 8, right: 8, zIndex: 10, backgroundColor: '#ffffff' }}
                    >
                        <CloseIcon />
                    </IconButton>
                    <img
                        src={zoomedImage || ''}
                        alt="Zoomed"
                        style={{ width: '100%', height: 'auto', display: 'block' }}
                    />
                </DialogContent>
            </Dialog>
        </Box>
    );
};